// extracted by mini-css-extract-plugin
export default {"hide_scrollbar":"style_hide_scrollbar__vfh4F"};